import { IRequestedStudy } from '@vivli/features/data-requests/infrastructure/interface';
import React from 'react';
import { PublishingRequestedStudyRowComponent } from './publishing-requested-study-row.component';

interface PublishingRequestedStudyRowPreviewComponentProps {
    requestedStudy: IRequestedStudy;
    index?: number;
    isConfigMode: false;
}

export const PublishingRequestedStudyRowPreviewComponent = ({
    requestedStudy,
    index,
    isConfigMode,
}: PublishingRequestedStudyRowPreviewComponentProps) => {
    return <PublishingRequestedStudyRowComponent requestedStudy={requestedStudy} index={index} isConfigMode={isConfigMode} />;
};
